import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Avatar,
  Chip,
  Divider,
  Box
} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import './EmpleadoCard.css';

function EmpleadoCard({ empleado, cardRef }) {
  const nombreFoto = empleado.nombre ? empleado.nombre.trim() : '';
  const fotoUrl = nombreFoto ? `/fotos/${nombreFoto}.png` : null;
  const [imgError, setImgError] = React.useState(false);

  const obtenerMesAnterior = () => {
    const date = new Date();
    date.setMonth(date.getMonth() - 1);
    return date.toLocaleString('default', { month: 'long', year: 'numeric' });
  };

  return (
    <Card ref={cardRef} className="empleado-card">
      <CardContent className="empleado-card-content">
        {/* Avatar */}
        {fotoUrl && !imgError ? (
          <Avatar
            className="empleado-avatar"
            src={fotoUrl}
            alt={nombreFoto}
            onError={() => setImgError(true)}
          />
        ) : (
          <Avatar className="empleado-avatar fallback">
            <PersonIcon sx={{ fontSize: 50 }} />
          </Avatar>
        )}

        {/* Nombre */}
        <Typography variant="h6" className="empleado-nombre">
          {empleado.nombre} {empleado.apellido}
        </Typography>

        {/* Rol */}
        <Chip label="Peluquero" className="empleado-chip" />

        <Divider className="empleado-divider" />

        {/* Detalles */}
        <Typography variant="subtitle1" className="empleado-detalles-titulo">
          Detalles:
        </Typography>

        <Typography variant="body2" className="empleado-detalle">
          <strong>ID Login:</strong> {empleado.id_login_empleado}
        </Typography>
        <Typography variant="body2" className="empleado-detalle">
          <strong>Registro:</strong> {new Date(empleado.fecha_registro).toLocaleString()}
        </Typography>

        {/* 💲 Card Total debajo de Detalles */}
        <Box className="card-total-mes">
          <Box className="card-total-texto">
            <Typography variant="subtitle1" className="titulo-total-mes">
              Servicios Mes
            </Typography>
            <Typography variant="caption" className="subtitulo-total-mes">
              {obtenerMesAnterior()}
            </Typography>
            <Typography variant="h6" className="monto-total-mes">
              €{parseFloat(empleado.total_mes_anterior || 0).toFixed(2)}
            </Typography>
          </Box>
          <img src="/imagenes/exito.png" alt="Éxito" className="icono-total-mes" />
        </Box>
      </CardContent>
    </Card>
  );
}

export default EmpleadoCard;
